import { VuexModule, Module, Action, getModule } from "vuex-module-decorators";
import store from "@/store";

export interface ISettingsState {
  appVersion: string;
}

@Module({ namespaced: true, name: "settings" })
export class Settings extends VuexModule implements ISettingsState {
  _appVersion: string = process.env.PACKAGE_VERSION || "0";

  get appVersion() {
    return this._appVersion;
  }
}

//export const SettingsModule = getModule(Settings);
